var map = {
	"./world_-1.json": [
		568,
		568
	],
	"./world_-1000.json": [
		428,
		428
	],
	"./world_-200.json": [
		682,
		682
	],
	"./world_-2000.json": [
		861,
		861
	],
	"./world_-323.json": [
		138,
		138
	],
	"./world_-500.json": [
		565,
		565
	],
	"./world_1000.json": [
		760,
		760
	],
	"./world_117.json": [
		658,
		658
	],
	"./world_1279.json": [
		523,
		523
	],
	"./world_1492.json": [
		379,
		379
	],
	"./world_1530.json": [
		28,
		28
	],
	"./world_1650.json": [
		746,
		746
	],
	"./world_1715.json": [
		910,
		910
	],
	"./world_1783.json": [
		452,
		452
	],
	"./world_1815.json": [
		963,
		963
	],
	"./world_1830.json": [
		555,
		555
	],
	"./world_1850.json": [
		803,
		803
	],
	"./world_1861.json": [
		375,
		375
	],
	"./world_1872.json": [
		980,
		980
	],
	"./world_1880.json": [
		884,
		884
	],
	"./world_1914.json": [
		949,
		949
	],
	"./world_1920.json": [
		688,
		688
	],
	"./world_1938.json": [
		102,
		102
	],
	"./world_1939.json": [
		557,
		557
	],
	"./world_1940.json": [
		239,
		239
	],
	"./world_1941.json": [
		751,
		751
	],
	"./world_1942.json": [
		82,
		82
	],
	"./world_1943.json": [
		115,
		115
	],
	"./world_1944.json": [
		620,
		620
	],
	"./world_1945.json": [
		144,
		144
	],
	"./world_1946.json": [
		154,
		154
	],
	"./world_1994.json": [
		929,
		929
	],
	"./world_2020.json": [
		521,
		521
	],
	"./world_400.json": [
		477,
		477
	],
	"./world_600.json": [
		756,
		756
	],
	"./world_800.json": [
		418,
		418
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 920;
module.exports = webpackAsyncContext;